import React from "react";
import {FooterComponent} from "./components/FooterComponent";
import NavbarComponent from "./components/NavbarComponent";
import {BackToTopButton} from "./components/BackToTopButton";

export const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    return (
        <div className="min-h-screen flex flex-col">
            <NavbarComponent />
            <BackToTopButton />

            {/* Page content */}
            <main className="flex-grow">{children}</main>

            {/* Footer */}
            <FooterComponent />
        </div>
    );
};
